import { hasFeature } from '../../../../shared-components/contexts/InstitutionContext';
import { INotationWidgetFeatures } from '../Interfaces/INotationWidgetFeatures';

export function GetFeatures(type: string) {
  switch (type.toLowerCase()) {
    case 'alerts':
      return [
        {
          name: 'Audience',
          key: 'audience',
          helper:
            "If this is not enabled for this role, audience will default to 'Professional Staff'",
        },
        { name: 'Additional Audience', key: 'additionalAudience', helper: '' },
        { name: 'Assign To', key: 'assignTo', helper: '' },
        { name: 'Occurrence Date', key: 'occurenceDate', helper: '' },
        { name: 'Categories', key: 'categories', helper: '' },
        { name: 'Reasons', key: 'reasons', helper: '' },
      ] as INotationWidgetFeatures[];
    case 'encouragements':
      return [
        {
          name: 'Audience',
          key: 'audience',
          helper:
            "If this is not enabled for this role, audience will default to 'Full Network'",
        },
      ] as INotationWidgetFeatures[];
    case 'updates':
      return [
        {
          name: 'Audience',
          key: 'audience',
          helper:
            "If this is not enabled for this role, audience will default to 'Professional Staff'",
        },
        { name: 'Additional Audience', key: 'additionalAudience', helper: '' },
        { name: 'Occurrence Date', key: 'occurenceDate', helper: '' },
        { name: 'Categories', key: 'categories', helper: '' },
        { name: 'Reasons', key: 'reasons', helper: '' },
      ] as INotationWidgetFeatures[];
    case 'notation type select': {
      let features = [
        {
          name: 'Alerts',
          key: 'showAlerts',
          helper:
            'Control whether or not this role can create Alerts via the widget',
        },
        {
          name: 'Updates',
          key: 'showUpdates',
          helper:
            'Control whether or not this role can create Updates via the widget',
        },
      ] as INotationWidgetFeatures[];

      if (hasFeature('Encouragements')) {
        features.push({
          name: 'Encouragements',
          key: 'showEncouragements',
          helper:
            'Control whether or not this role can create Encouragements via the widget',
        } as INotationWidgetFeatures);
      }
      return features;
    }
    default:
      return [...Array(0)] as INotationWidgetFeatures[];
  }
}
